import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const STORAGE_KEY = 'lux_selected_company';

const CompanyScopeContext = createContext({
  companies: [],
  selectedCompanyId: '',
  setSelectedCompanyId: () => {},
  isCrossCompany: false,
  loading: false,
});

export function CompanyScopeProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCompanyId, setSelectedCompanyIdState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ''
  );

  const isCrossCompany =
    !!user && ['super_admin', 'group_admin', 'group_hr'].includes(user.role);

  useEffect(() => {
    if (!isAuthenticated || !isCrossCompany) {
      setCompanies([]);
      return;
    }
    let mounted = true;
    setLoading(true);
    api
      .get('/companies')
      .then((r) => {
        if (mounted) setCompanies(r.data || []);
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, [isAuthenticated, isCrossCompany]);

  const setSelectedCompanyId = useCallback((id) => {
    setSelectedCompanyIdState(id || '');
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  }, []);

  return (
    <CompanyScopeContext.Provider
      value={{
        companies,
        selectedCompanyId,
        setSelectedCompanyId,
        isCrossCompany,
        loading,
      }}
    >
      {children}
    </CompanyScopeContext.Provider>
  );
}

export const useCompanyScope = () => useContext(CompanyScopeContext);
